<template>
  <div class="cart-item-qty-container">
    <div v-if="editing" class="editing">
      <div class="input-group">
        <input
          id="quantity-input"
          v-model="selectedQuantity"
          type="number"
          :min="
            cart.cartItems[cartItemIndex].testDriveSubscribers.length === 0
              ? 1
              : cart.cartItems[cartItemIndex].testDriveSubscribers.length
          "
          max="50"
          step="1"
          class="form-control"
        />
        <span class="input-group-btn">
          <button
            class="btn btn-sm btn-primary"
            type="button"
            @click="updateCartItem"
          >
            <small>Update</small>
          </button>
        </span>
      </div>
      <button
        id="cancel-button"
        class="item-quantity-button btn btn-secondary"
        type="button"
        @click="editing = !editing"
      >
        <small>Cancel</small>
      </button>
    </div>
    <div v-else class="item-quantity-button-group-wrapper">
      <span class="quantity-label">
        <b>Qty: {{ cart.cartItems[cartItemIndex].quantity }}</b>
      </span>
      <div class="btn-group" role="group" aria-label="Edit shopping cart item">
        <button
          class="item-quantity-button btn btn-outline-primary"
          type="button"
          @click="editing = !editing"
        >
          <small>Edit</small>
        </button>
        <button
          id="delete-item-button"
          class="item-quantity-button btn btn-primary"
          type="button"
          @click="confirmDelete"
        >
          <small>Delete</small>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import swal from "sweetalert2";

export default {
  name: "CartItemQuantity",
  props: {
    cartItemIndex: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      editing: false,
      selectedQuantity: null,
    };
  },
  computed: {
    ...mapState(["cart"]),
  },
  beforeMount() {
    this.selectedQuantity = this.cart.cartItems[this.cartItemIndex].quantity;
  },
  methods: {
    deleteItem(event, itemId = this.cart.cartItems[this.cartItemIndex].itemId) {
      this.$store.dispatch("cart/deleteCartItem", itemId);
    },
    updateCartItem(
      event,
      itemId = this.cart.cartItems[this.cartItemIndex].itemId
    ) {
      this.editing = !this.editing;
      const quantity = this.selectedQuantity;
      this.$store.dispatch("cart/updateCartItemQuantity", {
        itemId,
        quantity,
      });
    },
    confirmDelete(event) {
      swal
        .fire({
          title: "Just checking...",
          type: "question",
          html: `
          <div style="font-size: small">
          <p style="margin: auto">Are you sure you would like to remove</p>
          <p style="max-width: 80%; margin: auto"><b>${
            this.cart.cartItems[this.cartItemIndex].label
          }</b>
          <p style="margin: auto">from your shopping cart?</p>
          </div>
        `,
          showCancelButton: true,
          cancelButtonText: "No, keep in cart",
          cancelButtonColor: "rgb(92, 184, 92)",
          confirmButtonText: "Yes, remove from cart",
          confirmButtonColor: "rgb(217, 83, 79)",
        })
        .then((result) => {
          if (result.value) {
            this.deleteItem(event);
          }
        });
    },
  },
};
</script>

<style scoped>
.btn-outline-primary {
  border: 1px solid #d16c00 !important;
  color: #d16c00;
  background: none;
}

.btn-outline-primary:hover {
  border: 1px solid #d16c00;
  background: #f5e1cc;
}

#cancel-button {
  margin-left: 0.5rem;
}

.cart-item-qty-container {
  text-align: left;
  position: relative;
}

.cart-item-qty-container .editing {
  display: flex;
  flex-direction: row;
  justify-content: center;
  margin-bottom: 20px;
}

#delete-item-button {
  border: 1px solid #d16c00;
}

.input-group {
  max-width: 144px;
  border-radius: 1rem;
  margin: 0;
}

.item-quantity-button {
  padding: 0.5rem 1rem;
}

.item-quantity-select {
  position: fixed;
  background: #ffffff;
  border: 1px solid #666666;
  border-radius: 0.5rem;
  padding: 0.5rem 0;
  z-index: 100;
}

.item-quantity-select a {
  padding: 0.5rem 1rem;
  display: block;
}

.item-quantity-select a:hover {
  background-color: #eeeeee;
}

.item-quantity-select ul {
  display: flex;
  flex-direction: column;
  list-style-type: none;
  margin: 0;
  margin-block-start: 0;
  margin-block-end: 0;
  padding: 0;
}

.item-quantity-select ul li {
  display: block;
}

.item-quantity-button-group-wrapper {
  padding: 1px 0;
}

#quantity-input {
  border-radius: 1rem 0 0 1rem;
  height: 31px;
  border: 1px solid #d16c00;
}

.quantity-label {
  font-size: 90%;
  margin-right: 1rem;
}
</style>
